export default __webpack_public_path__ + "static/media/143.8c8066e4.jpg";